export function isValidPlate(plate: string): boolean {
  const regex = /^[A-Z]{3}[0-9][0-9A-Z][0-9]{2}$/;
  return regex.test(plate.toUpperCase());
}
